export enum ScanType {
  QuickFlow = 'QuickFlow',
  SlowFlow = 'SlowFlow'
}
